export const cssConstants = {
    SPACE_BETWEEN: "space-between",
};
